import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { NestedMenuItem } from "mui-nested-menu";
import { ChevronDownIcon, ChevronUpIcon, ChevronRightIcon } from "lucide-react";

const NestedMenu = ({ label, menus, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoverPath, setHoverPath] = useState([]);

  const open = Boolean(anchorEl);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setHoverPath([]);
  };

  const handleAction = (item) => {
    if (item?.onClick) item.onClick();
    handleClose();
  };

  const paperStyle = {
    border: "2px solid var(--primaryMD-color)",
    borderRadius: "10px",
    boxShadow: "var(--shadow-lg)",
  };

  const renderMenuItems = (items, parentOpen, path = []) =>
    items.map((item, index) => {
      const currentPath = [...path, index];
      const isActive =
        hoverPath.length >= currentPath.length &&
        currentPath.every((v, i) => v === hoverPath[i]);

      if (item.child?.length) {
        return (
          <NestedMenuItem
            key={index}
            label={item.title}
            parentMenuOpen={parentOpen}
            rightIcon={<ChevronRightIcon size={16} />}
            onMouseEnter={() => setHoverPath(currentPath)}
            MenuProps={{
              disableAutoFocusItem: true,
              disableEnforceFocus: true,
              PaperProps: { sx: paperStyle },
            }}
            tabIndex={-1}
            sx={{
              backgroundColor: isActive ? "action.selected" : "transparent",
              "&:hover": { backgroundColor: "action.hover" },
            }}
            className="!text-gray-700"
          >
            {renderMenuItems(item.child, parentOpen, currentPath)}
          </NestedMenuItem>
        );
      }

      return (
        <MenuItem
          key={index}
          onClick={() => handleAction(item)}
          onMouseEnter={() => setHoverPath(currentPath)}
          tabIndex={-1}
          disableRipple
          disableTouchRipple
          sx={{
            paddingLeft: "12px",
            backgroundColor: isActive ? "action.selected" : "transparent",
            "&:hover": { backgroundColor: "action.hover" },
          }}
          className="!text-gray-700"
        >
          {item.title}
        </MenuItem>
      );
    });

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="contained"
        disabled={disabled}
        endIcon={
          open ? <ChevronUpIcon size={18} /> : <ChevronDownIcon size={18} />
        }
      >
        {label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocusItem
        disableEnforceFocus
        PaperProps={{ sx: paperStyle }}
      >
        {renderMenuItems(menus, open)}
      </Menu>
    </>
  );
};

export default NestedMenu;
